import { inject, Injectable } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { MenuItem } from "primeng/api";
import { map, Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class MenuService {

    private translationService: TranslocoService = inject(TranslocoService);

    /** Emits again on every language change, so the labels stay in sync with the active language. */
    getMenuItems(): Observable<MenuItem[]> {
        return this.translationService.selectTranslation().pipe(
            map(() => this.buildMenu())
        );
    }

    private buildMenu(): MenuItem[] {
        const t = (key: string) => this.translationService.translate(`menu.${key}`);

        return [
            {
                icon: 'pi pi-home',
                routerLink: '/',
                styleClass: 'menu-home-button',
                routerLinkActiveOptions: { exact: true }
            },
            {
                label: t('charging-infrastructure.title'),
                icon: 'fa-regular fa-charging-station',
                items: [
                    {
                        label: t('charging-infrastructure.chargers'),
                        routerLink: '/chargers',
                        routerLinkActiveOptions: { exact: false },
                    },
                    {
                        label: t('charging-infrastructure.connectors'),
                        routerLink: '/connectors',
                        routerLinkActiveOptions: { exact: false },
                    },
                    {
                        label: t('charging-infrastructure.cdrs'),
                        routerLink: '/cdrs',
                        routerLinkActiveOptions: { exact: false },
                    }
                ]
            },
            {
                label: t('charging-control.title'),
                icon: 'fa-regular fa-sliders-up',
                items: [
                    {
                        label: t('charging-control.rfid-groups'),
                        routerLink: '/rfid-groups',
                        routerLinkActiveOptions: { exact: false },
                    },
                    {
                        label: t('charging-control.charger-groups'),
                        routerLink: '/charger-groups',
                        routerLinkActiveOptions: { exact: false },
                    },
                    {
                        label: t('charging-control.locations'),
                        routerLink: '/locations',
                        routerLinkActiveOptions: { exact: false },
                    },
                    {
                        label: t('charging-control.incidents'),
                        routerLink: '/incidents',
                        routerLinkActiveOptions: { exact: false },
                    }
                ]
            },
            {
                label: t('settings.title'),
                icon: 'fa-regular fa-gear',
                items: [
                    {
                        label: t('settings.companies'),
                        routerLink: '/companies',
                        routerLinkActiveOptions: { exact: false },
                    },
                    {
                        label: t('settings.grid-operators'),
                        routerLink: '/grid-operators',
                        routerLinkActiveOptions: { exact: false },
                    },
                    {
                        label: t('settings.tariffs'),
                        routerLink: '/tariffs',
                        routerLinkActiveOptions: { exact: false },
                    },
                    {
                        label: t('settings.configuration-profiles'),
                        routerLink: '/configuration-profiles',
                        routerLinkActiveOptions: { exact: false },
                    },
                    {
                        label: t('charging-control.smart-cars'),
                        routerLink: '/smart-cars',
                        routerLinkActiveOptions: { exact: false },
                    }
                ]
            },
            {
                label: t('billing.title'),
                icon: 'fa-regular fa-list-check',
                items: [
                    {
                        label: t('billing.overview'),
                        routerLink: '/billing/internal/overview',
                        routerLinkActiveOptions: { exact: false },
                    },
                    {
                        label: t('billing.payout-overview'),
                        routerLink: '/billing/stripe-and-payouts/overview',
                        routerLinkActiveOptions: { exact: false },
                    }
                ]
            }
        ];
    }
}
